import { Shape } from 'three';

export class CircleShape extends Shape {
  constructor(circleRadius: number, innerRadius?: number) {
    super();

    this.absarc(0, 0, circleRadius, 0, Math.PI * 2, false);

    if (innerRadius) {
      this.holes.push(new CircleShape(innerRadius));
    }
  }
}

export default CircleShape;
